module.exports = __webpack_public_path__ + "static/tmknom-7b29c05c913674a1695550abda33f80e.jpg";